<app-loading *ngIf="loaderService.loading | async"></app-loading>
<app-internal-header></app-internal-header>

<div class="content" [class.no-padding]="isRouteWithNewUx">
  <router-outlet></router-outlet>
</div>